export interface AssetClassTag {
  order: string;
  name: string;
}

export interface RegulatoryMix {
  equity: number;
  fixedIncome: number;
  alternatives: number;
}

export function regulatoryMix(
  items: readonly { weight: number | null; classes?: readonly AssetClassTag[] }[],
  orderId: string,
): RegulatoryMix | null {
  const mix: RegulatoryMix = { equity: 0, fixedIncome: 0, alternatives: 0 };
  let total = 0;
  for (const item of items) {
    const weight = item.weight ?? 0;
    if (!Number.isFinite(weight) || weight <= 0) continue;
    const name = item.classes?.find((tag) => tag.order === orderId)?.name;
    if (!name) return null;
    mix[bucketOf(name)] += weight;
    total += weight;
  }
  if (total <= 0) return null;
  return {
    equity: mix.equity / total,
    fixedIncome: mix.fixedIncome / total,
    alternatives: mix.alternatives / total,
  };
}

export function classTagsOf(
  classes:
    | readonly {
        name?: string | null;
        quant_asset_class_order_id?: string | number | null;
      }[]
    | null
    | undefined,
): AssetClassTag[] {
  return (classes ?? []).flatMap((entry) => {
    const name = entry?.name?.trim();
    const order = entry?.quant_asset_class_order_id;
    return name && order != null ? [{ order: String(order), name }] : [];
  });
}

function bucketOf(name: string): keyof RegulatoryMix {
  if (name === EQUITY_CLASS_NAME) return "equity";
  if (name === FIXED_INCOME_CLASS_NAME) return "fixedIncome";
  return "alternatives";
}

const EQUITY_CLASS_NAME = "Aktier";
const FIXED_INCOME_CLASS_NAME = "Räntor";
